import type {MouseEvent, ReactNode} from "react";
import {css} from "@panda/css";

import {trackAmplitudeButtonClick} from "../../../../tracking/amplitude/track_amplitude_button_click";

interface IProps {
    children: ReactNode;
    offerId: number;
}

export const OfferDetailPropertyListViewToggleTracking = (props: IProps) => {
    const {children, offerId} = props;

    const trackPropertyListTypeClick = (event: MouseEvent<HTMLDivElement>) => {
        const clickedElement = event.target;

        if (!(clickedElement instanceof Element)) {
            return;
        }

        const value = propertyListViewValueByButtonLabel[clickedElement.closest("button")?.textContent?.trim() ?? ""];

        if (!value) {
            return;
        }

        trackAmplitudeButtonClick({
            buttonName: "offers_view_toggle",
            value,
            buttonCategory: "investment_page",
            itemId: offerId
        });
    };

    /*
     * The filters wait for an async properties refresh before changing the view. Capture the original click so a
     * rejected request cannot drop the event.
     */
    return (
        <div className={wrapperStyle} onClickCapture={trackPropertyListTypeClick}>
            {children}
        </div>
    );
};

const wrapperStyle = css({
    display: "contents"
});

const propertyListViewValueByButtonLabel: Record<string, "floor_plans" | "list"> = {
    Rzuty: "floor_plans",
    Lista: "list"
};
import type {MouseEvent, ReactNode} from "react";
import {css} from "@panda/css";

import {trackAmplitudeButtonClick} from "../../../../tracking/amplitude/track_amplitude_button_click";

interface IProps {
    children: ReactNode;
    offerId: number;
}

export const OfferDetailPropertyListViewToggleTracking = (props: IProps) => {
    const {children, offerId} = props;

    const trackPropertyListTypeClick = (event: MouseEvent<HTMLDivElement>) => {
        const clickedElement = event.target;

        if (!(clickedElement instanceof Element)) {
            return;
        }

        const value = propertyListViewValueByButtonLabel[clickedElement.closest("button")?.textContent?.trim() ?? ""];

        if (!value) {
            return;
        }

        trackAmplitudeButtonClick({
            buttonName: "offers_view_toggle",
            value,
            buttonCategory: "investment_page",
            itemId: offerId
        });
    };

    /*
     * The filters wait for an async properties refresh before changing the view. Capture the original click so a
     * rejected request cannot drop the event.
     */
    return (
        <div className={wrapperStyle} onClickCapture={trackPropertyListTypeClick}>
            {children}
        </div>
    );
};

const wrapperStyle = css({
    display: "contents"
});

const propertyListViewValueByButtonLabel: Record<string, "floor_plans" | "list"> = {
    Rzuty: "floor_plans",
    Lista: "list"
};
